import * as React from "react"

const SvgSettingsWrench = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M9 15.857q-2.5 0-4.25-1.75T3 9.857q0-.5.075-1t.275-.95a.94.94 0 0 1 .313-.375 1.2 1.2 0 0 1 .412-.175.96.96 0 0 1 .9.275L7.6 10.257l1.8-1.8-2.625-2.625a.97.97 0 0 1-.275-.9 1.2 1.2 0 0 1 .175-.412.94.94 0 0 1 .375-.313q.45-.2.95-.275t1-.075q2.5 0 4.25 1.75T15 9.857q0 .575-.1 1.088a5.7 5.7 0 0 1-.3 1.012l5.05 5q.725.725.725 1.775c0 1.05-.242 1.292-.725 1.775q-.725.725-1.775.725c-1.05 0-1.292-.25-1.775-.75l-5-5.025q-.5.2-1.012.3a5.7 5.7 0 0 1-1.088.1m0-2q.65 0 1.3-.2a3.5 3.5 0 0 0 1.175-.625l6.075 6.075a.42.42 0 0 0 .337.113.5.5 0 0 0 .338-.138.46.46 0 0 0 .125-.337.46.46 0 0 0-.125-.338l-6.075-6.05q.45-.5.65-1.162.2-.663.2-1.338 0-1.5-.963-2.612A3.86 3.86 0 0 0 9.65 5.907l1.85 1.85q.3.3.3.7t-.3.7l-3.2 3.2q-.3.3-.7.3a.96.96 0 0 1-.7-.3l-1.85-1.85q.225 1.425 1.338 2.388T9 13.857" />
  </svg>
)
export default SvgSettingsWrench
